module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Dane ogólne")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Nagłówek",
      "error": _vm.errors['header']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.notice.header),
      callback: function($$v) {
        _vm.notice.header = $$v
      },
      expression: "notice.header"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Treść",
      "error": _vm.errors['content']
    }
  }, [_c('textarea-input', {
    attrs: {
      "rows": "5"
    },
    model: {
      value: (_vm.notice.content),
      callback: function($$v) {
        _vm.notice.content = $$v
      },
      expression: "notice.content"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Data",
      "error": _vm.errors['date']
    }
  }, [_c('date-picker', {
    model: {
      value: (_vm.notice.date),
      callback: function($$v) {
        _vm.notice.date = $$v
      },
      expression: "notice.date"
    }
  })], 1)], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Zdjęcia")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Zdjęcia",
      "error": _vm.errors['photos']
    }
  }, [_c('media-input', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.notice.photos),
      callback: function($$v) {
        _vm.notice.photos = $$v
      },
      expression: "notice.photos"
    }
  })], 1)], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Pliki")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Pliki",
      "error": _vm.errors['files']
    }
  }, [_c('media-input', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.notice.files),
      callback: function($$v) {
        _vm.notice.files = $$v
      },
      expression: "notice.files"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    attrs: {
      "submitting": _vm.submitting
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fd9b974","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoticeAddEdit.vue
// module id = 460
// module chunks = 1